import { ITrainingsContent } from '../interfaces/i-training';
import trainingsContent from './trainings.json';

/**
 * Conteúdo dos treinamentos. Para incluir/editar módulos e aulas basta mexer no
 * `trainings.json` — a tipagem abaixo garante que o arquivo continue seguindo o
 * contrato de `ITrainingsContent`.
 */
const content: ITrainingsContent = trainingsContent;

export const trainingModules = content.modulos || [];
